export default "__VITE_ASSET__CQLkpYXE__"